import React, { useState } from 'react'
import bootstrapScopedStyles from './../../styles/bootstrapScoped.min.module.css'
import colors from '../../branding/colors'
import mobileStyles from '../../styles/mobileStyles.module.css'

import {
  onfsLinkStyle,
  onfsLinkStyleHovered
} from '../../branding/onfsLinkStyles'

export default function OnfsButton({
  label,
  className = '',
  link = false,
  style = {},
  inverted = false,
  ...rest
}) {
  const backgroundColor = style.background || colors.primaryGradient
  const color = style.color || colors.light
  let baseButtonStyle

  if (link) {
    baseButtonStyle = { ...onfsLinkStyle, ...style }
  } else {
    baseButtonStyle = {
      fontWeight: 'bold',
      outline: '1pt solid',
      ...style,
      background: backgroundColor,
      color: color
    }
    if (inverted) {
      // color is checking if it's a linear gradient -- if it is, we just take the first color of the gradient
      baseButtonStyle = {
        ...style,
        background: baseButtonStyle.color,
        color: baseButtonStyle.background.toString().match('linear-gradient')
          ? baseButtonStyle.background.match(/(?<=\()(.*?)(?=,)/g)
          : baseButtonStyle.background,
        fontWeight: 'bold',
        outline: '1pt solid'
      }
    }
  }

  const [isHovered, setIsHovered] = useState(false)

  // Eventually support other default styles without having to pass custom styling
  // if(props?.type.toUpperCase() === "secondary".toUpperCase()) {

  // }

  let buttonStyle = {}
  if (isHovered) {
    if (link) {
      buttonStyle = { ...baseButtonStyle, ...onfsLinkStyleHovered }
    } else {
      buttonStyle = {
        ...baseButtonStyle,
        textDecoration: 'underline',
        background: style.background || colors.primaryGradientHovered,
        color: isHovered && inverted ? colors.light : color
      }
    }
  } else if (!isHovered) {
    buttonStyle = { ...baseButtonStyle }
  }

  let classes = className

  if (!link) {
    classes = `${bootstrapScopedStyles.btn} ${className} ${mobileStyles['btn-xs-block']} `
  }

  return (
    <div className={bootstrapScopedStyles['bootstrap-scope']}>
      <button
        className={classes}
        style={buttonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
        {...rest}
      >
        {label}
      </button>
    </div>
  )
}
